export const useCurationImage = (
  def : PartImage = null,
) => {

  const { isJa } = useI18n()
  const { compImageSelection } = useImageSelection()

  const _def: Ref<PartImage> = ref(def)

  const imageClass = computed((): ImageLayout => {
    return _def.value.layout
  })

  const heightStyle = computed((): object => {
    return {
      height: _def.value.height || '250px',
    }
  })

  const imageSelection = computed((): ImageSelection => {
    if ( isJa.value || isEmpty(_def.value.imageEn)) {
      return compImageSelection(_def.value.image)
    } else {
      return compImageSelection(_def.value.imageEn)
    }
  })

  const background = computed((): string => {
    if (_def.value.background) {
      switch (_def.value.background) {
        case 'none':
          return 'transparent'
        case 'black':
          return '#2B2B2B'
        case 'grey':
          return null
      }
    }
    return null
  })

  const hasCaption = computed((): boolean => {
    return !isEmpty(_def.value.caption)
  })

  const hasDescription = computed((): boolean => {
    return !isEmpty(_def.value.description)
  })

  const hasText = computed((): boolean => {
    return hasCaption.value || hasDescription.value
  })

  const updateDef = (def : PartImage) => {
    _def.value = def
  }

  return {
    imageClass,
    heightStyle,
    imageSelection,
    background,
    hasCaption,
    hasDescription,
    hasText,
    updateDef,
  }

}

